import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { RecreateEsriSnapshot, RecreateEsriSnapshotVariables } from "./__generated__/RecreateEsriSnapshot";

const RECREATE_ESRI_SNAPSHOT = gql`
  mutation RecreateEsriSnapshot($id: String!) {
    recreateEsriSnapshot(input: { id: $id }) {
      success
    }
  }
`;

export function useRecreateEsriSnapshot() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    RecreateEsriSnapshot,
    RecreateEsriSnapshotVariables
  >(RECREATE_ESRI_SNAPSHOT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
